import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function getBlogsList(data) {
      try {
            const response = await callPostApi({ url: "cms-blog/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getBlogDetail(blogId) {
      try {
            const response = await callGetApi({ url: "cms-blog/" + blogId });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function createBlog(postData) {
      try {
            const response = await callPostApi({ url: "cms-blog", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateBlog(postData) {
      try {
            const response = await callPutApi({ url: "cms-blog", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function deleteBlog(id) {
      try {
            const response = await callDeleteApi({ url: "cms-blog/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getCategoryLookup() {
      try {
            const response = await callGetApi({ url: "cms-blog/category/lookup" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getAllBlogsList() {
      try {
            const response = await callPostApi({ url: "cms-blog/blog-name-list" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getBlogCategoryList(postData) {
      try {
            const response = await callPostApi({ url: "cms-blog/category/list", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getBlogCategoryAdd(postData) {
      try {
            const response = await callPostApi({ url: "cms-blog/category", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getBlogCategoryUpdate(postData) {
      try {
            const response = await callPutApi({ url: "cms-blog/category/", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function deleteBlogCategory(id) {
      try {
            const response = await callDeleteApi({ url: "cms-blog/category/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}


